import { atom } from 'recoil';

export const toggleSspModels = atom({
    key: 'aws-kafka-topic-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isDatabaseNameModalOpen: false,
        isConsumerGroupOpen: false,
    },
});

export const isMandatoryTagsFullfilled = atom({
    key: 'aws-kafka-topic-isMandatoryTagsFullfilled',
    default: false,
});

export const environmentDetails = atom({
    key: 'aws-kafka-topic-environmentDetails',
    default: {
        Application_Manager: '---',
        Project: '---',
    },
});

export const orderId = atom({
    key: 'aws-kafka-topic-orderId',
    default: '',
});

export const sspSubmitOrder = atom({
    key: 'aws-kafka-topic-sspOrder',
    default: {
        // Application Section
        applicationName: null,
        appShortName: null,
        appProfile: null,
        drPriority: null,
        entityDetails: null,
        sector: null,
        sectorDetails: null,
        appRegion: null,
        environment: null,
        regionDetails: null,
        hCode: null,
        hCodeDetails: null,
        appOwner: null,
        appOwnerDetails: null,
        appSupportMailId: null,
        billingEntity: null,
        billingEntityDetails: null,
        businessUnit: null,
        businessUnitDetails: null,
        isaDocument: null,
        ldap: null,

        // Resource Section
        awsAccount: null,
        awsAccountId: null,
        department: null,
        cluster: null,
        clusterDetails: null,
        project: null,
        catalogSize: null,
        catalogSizeDetails: null,

        // Kafka Topic Configuration Section
        topic: '',
        partitions: null,
        consumerGroupRadio: 'no',
        consumerGroupList: [{ value: '' }],
        isReadAccessRequired: null,
        isReadAccessUser: null,
        isWriteAccessUser: null,
        writeAccessGroupOwner: null,
        writeAccessGroupOwnerDetails: null,
        writeIDX: '',
        transactionalId: 'no',
        transactionPrefixText: '',
        transactionPrincipalId: '',
        retention: null,
        retentionUnit: 'In Days',
        retentionDetails: null,
        readAccessGroupOwner: null,
        readAccessGroupOwnerDetails: null,
        adGroupOwner: null,
        adGroupOwnerDetails: null,
        readIDX: '',

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const isValidappSupportMailId = atom({
    key: 'aws-kafka-topic-isValidappSupportMailId',
    default: false,
});

export const costEstimateState = atom({
    key: 'aws-kafka-topic-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'aws-kafka-topic-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isValidLdapGroup = atom({
    key: 'aws-kafka-topic-isValidLdapGroup',
    default: false,
});

export const isValidProject = atom({
    key: 'aws-kafka-topic-isValidProject',
    default: false,
});

export const isValidTopic = atom({
    key: 'aws-kafka-topic-isValidTopic',
    default: false,
});

export const disableGroupOwnerFields = atom({
    key: 'aws-kafka-topic-disableGroupOwnerFields',
    default: {
        writeAccessGroupOwner: false,
        readAccessGroupOwner: false,
    },
});

export const isValidReadIdxAccount = atom({
    key: 'aws-kafka-topic-isValidReadIdxAccount',
    default: false,
});

export const isValidWriteIdxAccount = atom({
    key: 'aws-kafka-topic-isValidWriteIdxAccount',
    default: false,
});

export const isValidTransactionPrefixText = atom({
    key: 'aws-kafka-topic-isValidTransactionPrefixText',
    default: false,
});

export const isValidTransactionPrincipalId = atom({
    key: 'aws-kafka-topic-isValidTransactionPrincipalId',
    default: false,
});

export const SecondaryApproverBanner = atom({
    key: 'aws-kafka-topic-SecondaryApproverBanner',
    default: { status: false, message: null },
});

export const isCostcenterValid = atom({
    key: 'aws-kafka-topic-isCostcenterValid',
    default: false,
});
